export class VendedorComissaoFaixaStruct {
    descontoAtePercentual: number;
    comissaoPercentual: number;
}